var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vm-icon-pay-group flex-box",class:{
        'wechat-env': _vm.GL.ENV.is_wechat,
        'alipay-env': _vm.GL.ENV.is_alipay,
        'abroad-env': _vm.GL.ENV.is_abroad,
    }},_vm._l((_vm.list),function(item){return _c('icon-pay',{key:item,staticClass:"mq",class:{
            on: _vm.pay_type == item,
            disable:
                (_vm.is_enable_disable && _vm.GL.ENV.is_wechat && item == 'alipay') ||
                (_vm.GL.ENV.is_alipay && item == 'wxpay') ||
                (_vm.GL.ENV.is_xiaoyuzhou && item == 'wxpay'),
        },attrs:{"name":item,"is_hide_lijian":_vm.is_hide_lijian,"tuijian_type":_vm.tuijian_type},nativeOn:{"click":function($event){return _vm.select_pay(item)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }